import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useMatter } from '@/hooks/useMatter';

export const CheckInPageWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { matterId } = useMatter();
  const navigate = useNavigate();
  const handleBackToList = () => {
    navigate(`/matters/${matterId}/treatment/check-ins`);
  };
  return (
    <div className="p-4 sm:p-6 space-y-4">
      <Button variant="ghost" onClick={handleBackToList}>
        <ArrowLeft className="h-4 w-4" />
        Back to List
      </Button>
      {children}
    </div>
  );
};
